"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigData = void 0;
/* eslint-disable @typescript-eslint/no-var-requires */
var Utils_1 = require("../Utils");
var getConfigData = function (model) {
    var _a, _b;
    var config = (_b = model === null || model === void 0 ? void 0 : (_a = model.getDerivedData()).getModuleConfig) === null || _b === void 0 ? void 0 : _b.call(_a);
    config = ConfigBuilder.for(config)
        .withDynamicConfigData(model)
        .withDynamicComponents(model)
        .build();
    return config;
};
exports.getConfigData = getConfigData;
var ConfigBuilder = /** @class */ (function () {
    function ConfigBuilder(config) {
        var _this = this;
        this.build = function () {
            return _this.config;
        };
        this.withDynamicConfigData = function (model) {
            var _a;
            return new ConfigBuilder((_a = model === null || model === void 0 ? void 0 : model.getDerivedFunction("getDynamicConfigData", _this.config)) !== null && _a !== void 0 ? _a : _this.config);
        };
        this.withDynamicComponents = function (model) {
            var _a, _b;
            var dynamicComponents = (_b = model === null || model === void 0 ? void 0 : (_a = model.getDerivedFunctions()).getDynamicComponents) === null || _b === void 0 ? void 0 : _b.call(_a);
            if (dynamicComponents) {
                var dynamicComponentMap = (0, Utils_1.toDictionary)(dynamicComponents, function (component) {
                    var _a;
                    _this.config.UIGroups[component.group] =
                        (_a = _this.config.UIGroups[component.group]) !== null && _a !== void 0 ? _a : component.group;
                    return component.name;
                }, function (component) { return component; });
                _this.config.softwareData = __assign(__assign({}, _this.config.softwareData), dynamicComponentMap);
            }
            return new ConfigBuilder(_this.config);
        };
        this.config = config;
    }
    ConfigBuilder.for = function (config) {
        if (!config)
            throw console.error("Cannot find ModuleConfig");
        return new ConfigBuilder(config);
    };
    return ConfigBuilder;
}());
//# sourceMappingURL=getConfigData.js.map